<template functional>
  <div
    :class="{
      'd-flex flex-column align-end app-button-position-slot-button-margins':
        parent.$vuetify.breakpoint.smAndDown,
      'text-end': parent.$vuetify.breakpoint.mdAndUp
    }"
  >
    <slot />
  </div>
</template>
<script>
export default {
  name: "AppButtonPositionSlot"
};
</script>
<style>
.app-button-position-slot-button-margins button {
  margin: 8px !important;
}
</style>
